import { createSimpleEnumSerializer2guioz11kk1m0 as createSimpleEnumSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Enums.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { SortBuilder36qqny2jtmmgx as SortBuilder } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/SortBuilder.mjs';
import {
  LocationAttendancePeriod3bx3r7kkwecs9 as LocationAttendancePeriod,
  ID1z61wlmtvxrjn as ID,
  ID1m87d1hextx54 as ID_0,
  CareProvider2qcawrqluyllr as CareProvider,
  CareLocation1v3u5wduz023s as CareLocation,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/domain.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import {
  arrayOf1akklvh2at202 as arrayOf,
  toString30pk9tzaqopn as toString,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializerOrContextual2mm942ha7plg6 as serializerOrContextual } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/SerializationHelpers.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { DataClassPathSelf18kqeagzkbefr as DataClassPathSelf } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/DataClassPath.mjs';
import {
  get_periodnytt0bk9l5et as get_period,
  get_start1ib7kl469eh9c as get_start,
  get__id1301miildb0kq as get__id,
  get__id2p9nbcwbj0zlw as get__id_0,
  get__id21dvlw9jjogre as get__id_1,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/ModelFields-372156621.mjs';
import {
  Companion_instance13way2il9a8jt as Companion_instance,
  Enum3alwj03lh1n41 as Enum,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { enumEntries20mr21zbe3az4 as enumEntries } from '../../../../../../kotlin-kotlin-stdlib/kotlin/enums/EnumEntries.mjs';
import { LazyThreadSafetyMode_PUBLICATION_getInstance23f213579at67 as LazyThreadSafetyMode_PUBLICATION_getInstance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Lazy.mjs';
import { lazy1261dae0bgscp as lazy } from '../../../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import {
  SerializerFactory1qv9hivitncuv as SerializerFactory,
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
} from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { AppState_getInstance33x03n2an9aul as AppState_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/reactive/AppState.js.mjs';
import { get_stringsy7vodl9dj0ya as get_strings } from '../../strings.mjs';
import { get_currentSessionNotNull30vuua77prq38 as get_currentSessionNotNull } from '../../sdk/currentSession.mjs';
import {
  await1uwe8zvsjq69o as await_0,
  await1xlt6i5aa076q as await_1,
} from '../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { EmptySerializersModule991ju6pz9b79 as EmptySerializersModule } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/modules/SerializersModuleBuilders.mjs';
import { StringDeferringConfig2dp4ygunddfnv as StringDeferringConfig } from '../../../../../../kotlinx-serialization-csv-durable/com/lightningkite/kotlinx/serialization/csv/StringDeferringConfig.mjs';
import { CsvFormat2d7d3ollhiney as CsvFormat } from '../../../../../../kotlinx-serialization-csv-durable/com/lightningkite/kotlinx/serialization/csv/CsvFormat.mjs';
import {
  ListSerializer1hxuk9dx5n9du as ListSerializer,
  get_nullable197rfua9r7fsz as get_nullable,
} from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import { toBlob3efqyqa0phgb9 as toBlob } from '../../../../../../kiteui-library/com/lightningkite/kiteui/fetch.js.mjs';
import { download3e9i5zj8k9dp8 as download } from '../../../../../../kiteui-library/com/lightningkite/kiteui/ExternalServices.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import {
  constructCallableReference23y65rf941mch as constructCallableReference,
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { Queryam9ckqg1rxkb as Query } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/Query.mjs';
import { attendanceSheetCsv15opd55ow0c0p as attendanceSheetCsv } from './attendanceSheet.mjs';
import { AttendancePeriodDetailPage2fnxdkx3t2m6k as AttendancePeriodDetailPage } from './AttendancePeriodDetailPage.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LinearLayouts.commonHtml.mjs';
import {
  ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement,
  Companion_getInstanceztgx4sy4wjnt as Companion_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/NativeElement.mjs';
import {
  ChipSemantic_getInstancen74y1gyt9zmo as ChipSemantic_getInstance,
  IconButtonSemantic_getInstanceyhbmf43a1vw3 as IconButtonSemantic_getInstance,
} from '../../theme/semantics.mjs';
import {
  DangerSemantic_getInstance1xd9zwrvs99lp as DangerSemantic_getInstance,
  WarningSemantic_getInstance3kp0xfef7wnw4 as WarningSemantic_getInstance,
  AffirmativeSemantic_getInstance2svzxainpava5 as AffirmativeSemantic_getInstance,
  CompactSemantic_getInstance3lxnpjuev524m as CompactSemantic_getInstance,
  HeaderSemantic_getInstance20a9id3sf7d4x as HeaderSemantic_getInstance,
  get_H1Semantic28sytsa4fm6nk as get_H1Semantic,
  ListSemantic_getInstance2e62q1se6gw64 as ListSemantic_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { today1rno4frfjp5oe as today } from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/clock.mjs';
import {
  dynamicThemed3lsusnjffkq9e as dynamicThemed,
  themed2vu67ornd4jps as themed,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  TextView$_get_content_$ref_4pzcwl5a4gnldk8ef9 as TextView$_get_content_$ref_4pzcwl,
  TextView$_set_content_$ref_pketfb11e282hr0m0jl as TextView$_set_content_$ref_pketfb,
  IconView$_get_description_$ref_x7iif61khv8gb32hpy6 as IconView$_get_description_$ref_x7iif6,
  IconView$_set_description_$ref_rpvc1e1z9j41dqp1rw7 as IconView$_set_description_$ref_rpvc1e,
} from '../../App.mjs';
import {
  Companion_instance1lm8x0jadqh2g as Companion_instance_0,
  Platform_Web_getInstance2840w5bkfolz8 as Platform_Web_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/Platform.mjs';
import { get_current2r182tjucmm5v as get_current } from '../../../../../../kiteui-library/com/lightningkite/kiteui/Platform.js.mjs';
import {
  Signal1973xs1vkmdcb as Signal,
  _Constant___init__impl__v45mub2qfk15kh5l39c as _Constant___init__impl__v45mub,
  Constant3smypj7m9af27 as Constant,
} from '../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import {
  AttendancePeriodFilters2ya4mm5gzi7ou as AttendancePeriodFilters,
  attendancePeriodFilters294dkmracobiu as attendancePeriodFilters,
  filterChips1jx8e1a35uoqk as filterChips,
} from './AttendancePeriodFilters.mjs';
import {
  first58ocm7j58k3q as first,
  toList3jhuyej2anx2q as toList,
  toSet2orjxp16sotqu as toSet,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  Companion_getInstance2jahap30xtp3t as Companion_getInstance_0,
  toDuration7gy6v749ektt as toDuration,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { DurationUnit_MINUTES_getInstance33ilufdckt9os as DurationUnit_MINUTES_getInstance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
import { remember2m0mx1b5ra75q as remember } from '../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import {
  get_scrolling3fwkltztkpfe8 as get_scrolling,
  sizeConstraints19w9rda6g3rqz as sizeConstraints,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import {
  maxWidth22r11xnm7d4h4 as maxWidth,
  sortSelect2bs9xha2fqnl1 as sortSelect,
} from '../components/view-utilities.mjs';
import {
  get_atBottomStart1iulwjfo1udg3 as get_atBottomStart,
  get_centered31th09q7x90sf as get_centered,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import {
  weight31wqab1913ly4 as weight,
  shownWhen3t7othivfr11 as shownWhen,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import { MenuButton27en4jjgdkozz as MenuButton } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/MenuButton.commonHtml.mjs';
import { IconView32wln42r1v8cb as IconView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/IconView.commonHtml.mjs';
import {
  Companion_getInstance23x6zslwzj0st as Companion_getInstance_1,
  Companion_getInstance2h9rm1uihk6zf as Companion_getInstance_2,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { get_rem14pbkv8p42gid as get_rem } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { text189ciz0cnr32o as text } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/shortcuts.mjs';
import { Action2nhdpxpznfsbd as Action } from '../../../../../../kiteui-library/com/lightningkite/kiteui/reactive/Action.mjs';
import {
  Companion_instance35wmauq2koet0 as Companion_instance_1,
  tableRecycler8sos3tuo7qum as tableRecycler,
} from '../components/table.mjs';
import { Page1o437w9xuocrm as Page } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import {
  emptyList1g2z5xcrvp2zy as emptyList,
  listOfNotNull2woi2boe01ub4 as listOfNotNull,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { xDataClassPathInsideSet2a49hafkm1zud as xDataClassPathInsideSet } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/ConditionBuilder.mjs';
import { mapCapacity1h45rc3eh9p2l as mapCapacity } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { coerceAtLeast2bkz8m9ik7hep as coerceAtLeast } from '../../../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import {
  ID2ebczrc12h07k as ID_1,
  User3mqs8plvl8nwo as User,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/models.mjs';
import { addAll1k27qatfgp3k5 as addAll } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/MutableCollections.mjs';
import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginGeneratedSerialDescriptor.mjs';
import { LocalDateSerializer_getInstance3qg2c8779i3ej as LocalDateSerializer_getInstance } from '../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/serializers/LocalDateSerializers.mjs';
import { InstantSerializer_getInstance1n2pd669tdsta as InstantSerializer_getInstance } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/BuiltInSerializers.mjs';
import { StringSerializer_getInstance1p9zda6r6kb23 as StringSerializer_getInstance } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Primitives.mjs';
import { UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  equals2au1ep9vhcato as equals,
  createThis2j2avj17cvnv2 as createThis,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginExceptions.mjs';
import { SerializableWithd2dap36updxd as SerializableWith } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializersJs.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function _get_$cachedSerializer__te6jhj($this) {
  return $this.$cachedSerializer$delegate_1.get_value_j01efc_k$();
}
function AttendancePeriodsListPage$SortOption$Companion$_anonymous__w5om36() {
  return createSimpleEnumSerializer('org.thecommunitygroupinc.cares.views.attendance.AttendancePeriodsListPage.SortOption', values());
}
var static_init_called;
function static_init() {
  if (static_init_called)
    return Unit_instance;
  static_init_called = true;
  // Inline function 'com.lightningkite.services.database.sort' call
  // Inline function 'kotlin.apply' call
  var this_0 = new (SortBuilder())();
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp = serializerOrContextual(createKType(getKClass(LocationAttendancePeriod()), arrayOf([]), false));
  var tmp$ret$4 = isInterface(tmp, KSerializer()) ? tmp : THROW_CCE();
  var it = new (DataClassPathSelf())(tmp$ret$4);
  this_0.descending_tl4o2_k$(get_start(get_period(it)));
  var tmp$ret$0 = this_0.build_1k0s4u_k$();
  SortOption_NewestFirst_instance = new (SortOption())('NewestFirst', 0, 'Newest first', tmp$ret$0);
  // Inline function 'com.lightningkite.services.database.sort' call
  // Inline function 'kotlin.apply' call
  var this_1 = new (SortBuilder())();
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp_0 = serializerOrContextual(createKType(getKClass(LocationAttendancePeriod()), arrayOf([]), false));
  var tmp$ret$10 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
  var it_0 = new (DataClassPathSelf())(tmp$ret$10);
  this_1.ascending_ijynum_k$(get_start(get_period(it_0)));
  var tmp$ret$6 = this_1.build_1k0s4u_k$();
  SortOption_OldestFirst_instance = new (SortOption())('OldestFirst', 1, 'Oldest first', tmp$ret$6);
  if (Companion_instance_2 === VOID) {
    Companion_instance;
    new (Companion())();
  }
}
var SortOption_NewestFirst_instance;
var SortOption_OldestFirst_instance;
function values() {
  static_init();
  return [SortOption_NewestFirst_getInstance(), SortOption_OldestFirst_getInstance()];
}
function get_entries() {
  static_init();
  if ($ENTRIES == null)
    $ENTRIES = enumEntries(values());
  return $ENTRIES;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance_2 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.$cachedSerializer$delegate_1 = lazy(tmp_0, AttendancePeriodsListPage$SortOption$Companion$_anonymous__w5om36);
      }
      serializer_9w0wvi_k$() {
        return _get_$cachedSerializer__te6jhj(this);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_9w0wvi_k$();
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_2;
function Companion_getInstance_3() {
  static_init();
  return Companion_instance_2;
}
var $ENTRIES;
var SortOptionClass;
function SortOption() {
  if (SortOptionClass === VOID) {
    class $ extends Enum() {
      constructor(name, ordinal, displayName, sort) {
        super(name, ordinal);
        this.displayName_1 = displayName;
        this.sort_1 = sort;
      }
    }
    initMetadataForClass($, 'SortOption', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_3});
    SortOptionClass = $;
  }
  return SortOptionClass;
}
function AttendancePeriodsListPage$_get_title_$lambda_5e0g0($this$remember) {
  return $this$remember.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_attendancePeriodsPageTitle_1e29ef_k$();
}
function AttendancePeriodsListPage$render$lambda($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_attendancePeriodsPageTitle_1e29ef_k$();
}
function AttendancePeriodsListPage$render$lambda$lambda(it) {
  return it.displayName_1;
}
function AttendancePeriodsListPage$render$lambda_0($this$invoke) {
  return 'Export options';
}
function AttendancePeriodsListPage$render$lambda$slambda(this$0, $$this$button) {
  return constructCallableReference(($this$Action, $completion) => orPromise($completion, function *($completion) {
    var tmp = Companion_instance_3;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = get_currentSessionNotNull();
    var tmp_0 = (yield* await_0(this_0, $completion)).api_1;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = this$0.filter_1;
    var tmp$ret$1 = yield* await_1(this_1, $completion);
    var rows = yield* tmp.fetchAll_q0i359_k$(tmp_0, tmp$ret$1.toCondition_oj74tc_k$(), $completion);
    var csv = (new (CsvFormat())(new (StringDeferringConfig())(EmptySerializersModule(), VOID, ''))).encodeToString_k0apqx_k$(ListSerializer(Companion_instance_3.serializer_9w0wvi_k$()), rows);
    yield* download($$this$button.get_context_h02k06_k$(), 'attendance-periods.csv', toBlob(csv, 'text/csv'), VOID, $completion);
    return Unit_instance;
  }), 1);
}
function AttendancePeriodsListPage$render$lambda$slambda_0(this$0, $$this$button) {
  return constructCallableReference(($this$Action, $completion) => orPromise($completion, function *($completion) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = get_currentSessionNotNull();
    var tmp = (yield* await_0(this_0, $completion)).api_1.get_locationAttendancePeriod_ojr4ns_k$();
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = this$0.filter_1;
    var tmp$ret$1 = yield* await_1(this_1, $completion);
    var periods = yield* tmp.query_o986pg_k$(new (Query())(tmp$ret$1.toCondition_oj74tc_k$(), VOID, VOID, 2147483647), $completion);
    var tmp_0 = $$this$button.get_context_h02k06_k$();
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_2 = get_currentSessionNotNull();
    var tmp$ret$2 = yield* await_0(this_2, $completion);
    yield* download(tmp_0, 'attendance-sheets.csv', toBlob(yield* attendanceSheetCsv(tmp$ret$2.api_1, periods, false, $completion), 'text/csv'), VOID, $completion);
    return Unit_instance;
  }), 1);
}
function AttendancePeriodsListPage$render$lambda$slambda_1(this$0, $$this$button) {
  return constructCallableReference(($this$Action, $completion) => orPromise($completion, function *($completion) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = get_currentSessionNotNull();
    var tmp = (yield* await_0(this_0, $completion)).api_1.get_locationAttendancePeriod_ojr4ns_k$();
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = this$0.filter_1;
    var tmp$ret$1 = yield* await_1(this_1, $completion);
    var periods = yield* tmp.query_o986pg_k$(new (Query())(tmp$ret$1.toCondition_oj74tc_k$(), VOID, VOID, 2147483647), $completion);
    var tmp_0 = $$this$button.get_context_h02k06_k$();
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_2 = get_currentSessionNotNull();
    var tmp$ret$2 = yield* await_0(this_2, $completion);
    yield* download(tmp_0, 'attendance-sheets-blank.csv', toBlob(yield* attendanceSheetCsv(tmp$ret$2.api_1, periods, true, $completion), 'text/csv'), VOID, $completion);
    return Unit_instance;
  }), 1);
}
function AttendancePeriodsListPage$render$lambda_1(it) {
  return new (AttendancePeriodDetailPage())(it._id_1);
}
function AttendancePeriodsListPage$render$lambda_2($this$text) {
  return $this$text.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_attendancePeriodLabel_4v4nxb_k$();
}
function AttendancePeriodsListPage$render$lambda_3($this$text, it) {
  return it.period_1.toString();
}
function AttendancePeriodsListPage$render$lambda_4($this$text) {
  return $this$text.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_attendanceLocationColumnLabel_dz9caf_k$();
}
function AttendancePeriodsListPage$render$lambda_5($this$text, it) {
  var tmp0_safe_receiver = $this$text.invoke_r7m7el_k$($this$text.invoke_r7m7el_k$(get_currentSessionNotNull()).get_careLocations_f1rtw_k$().get_6ueaa7_k$(new (ID())(it.location_1)));
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.name_1;
  return tmp1_elvis_lhs == null ? $this$text.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_attendanceUnknownLocationLabel_l7955l_k$() : tmp1_elvis_lhs;
}
function AttendancePeriodsListPage$render$lambda_6($this$custom) {
  return $this$custom.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_attendanceSubmittedColumnLabel_fx9tt7_k$();
}
function AttendancePeriodsListPage$render$lambda_7($this$custom, it) {
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (RowOrCol())($this$custom.get_context_h02k06_k$());
  ensureOutermostElement(element);
  $this$custom.willAddChild_hz2iwc_k$(element);
  element.set_vertical_nuap32_k$(false);
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  var this_0 = dynamicThemed(element, ($this$dynamicThemed) => {
    var tmp = ChipSemantic_getInstance();
    var tmp_0;
    if (!($this$dynamicThemed.invoke_r7m7el_k$(it).submitted_1 == null)) {
      tmp_0 = AffirmativeSemantic_getInstance();
    } else {
      tmp_0 = $this$dynamicThemed.invoke_r7m7el_k$(it).period_1.contains_3tkdvy_k$(today()) ? WarningSemantic_getInstance() : DangerSemantic_getInstance();
    }
    return tmp.plus_duvq05_k$(tmp_0);
  });
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_0 = new (TextView())(this_0.get_context_h02k06_k$());
  ensureOutermostElement(element_0);
  this_0.willAddChild_hz2iwc_k$(element_0);
  var tmp = KMutableProperty0();
  var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_0);
  var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_0));
  element_0.invoke_bnq13k_k$(tmp_1, ($this$invoke) => !($this$invoke.invoke_r7m7el_k$(it).submitted_1 == null) ? $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_attendanceStatusSubmitted_swmv6f_k$() : $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_attendanceStatusOpen_y91qpa_k$());
  element_0.onStartup_vrxh3i_k$();
  this_0.addChild_2qpft2_k$(element_0);
  element.onStartup_vrxh3i_k$();
  $this$custom.addChild_2qpft2_k$(element);
  return Unit_instance;
}
function AttendancePeriodsListPage$render$lambda_8($this$custom) {
  return $this$custom.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_attendanceApprovedColumnLabel_lbrr5h_k$();
}
function AttendancePeriodsListPage$render$lambda_9($this$custom, it) {
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (RowOrCol())($this$custom.get_context_h02k06_k$());
  ensureOutermostElement(element);
  $this$custom.willAddChild_hz2iwc_k$(element);
  element.set_vertical_nuap32_k$(false);
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  var this_0 = dynamicThemed(element, ($this$dynamicThemed) => ChipSemantic_getInstance().plus_duvq05_k$(!($this$dynamicThemed.invoke_r7m7el_k$(it).approved_1 == null) ? AffirmativeSemantic_getInstance() : WarningSemantic_getInstance()));
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_0 = new (TextView())(this_0.get_context_h02k06_k$());
  ensureOutermostElement(element_0);
  this_0.willAddChild_hz2iwc_k$(element_0);
  var tmp = KMutableProperty0();
  var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_0);
  var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_0));
  element_0.invoke_bnq13k_k$(tmp_1, ($this$invoke) => !($this$invoke.invoke_r7m7el_k$(it).approved_1 == null) ? $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_attendanceStatusApproved_oxievv_k$() : $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_attendanceStatusPending_wf20oj_k$());
  element_0.onStartup_vrxh3i_k$();
  this_0.addChild_2qpft2_k$(element_0);
  element.onStartup_vrxh3i_k$();
  $this$custom.addChild_2qpft2_k$(element);
  return Unit_instance;
}
function AttendancePeriodsListPage$render$lambda_10($this$shownWhen) {
  return get_current(Companion_instance_0).equals(Platform_Web_getInstance());
}
function SortOption_NewestFirst_getInstance() {
  static_init();
  return SortOption_NewestFirst_instance;
}
function SortOption_OldestFirst_getInstance() {
  static_init();
  return SortOption_OldestFirst_instance;
}
var AttendancePeriodsListPageClass;
function AttendancePeriodsListPage() {
  if (AttendancePeriodsListPageClass === VOID) {
    class $ {
      constructor() {
        this.filter_1 = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(new (AttendancePeriodFilters())());
        this.sort_1 = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(first(get_entries()));
        var tmp = this;
        tmp.data_1 = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
          var tmp = $this$remember.invoke_r7m7el_k$(get_currentSessionNotNull()).get_locationAttendancePeriods_kbvlcb_k$();
          var tmp0_condition = $this$remember.invoke_r7m7el_k$(this.filter_1).toCondition_oj74tc_k$();
          var tmp1_orderBy = $this$remember.invoke_r7m7el_k$(this.sort_1).sort_1;
          var tmp_0 = new (Query())(tmp0_condition, tmp1_orderBy, VOID, 50);
          // Inline function 'kotlin.time.Companion.minutes' call
          Companion_getInstance_0();
          var tmp$ret$0 = toDuration(5, DurationUnit_MINUTES_getInstance());
          return tmp.list$default_sjz00l_k$(tmp_0, VOID, tmp$ret$0);
        });
      }
      get_title_iz32un_k$() {
        return remember(VOID, VOID, VOID, VOID, AttendancePeriodsListPage$_get_title_$lambda_5e0g0);
      }
      render_w3x9d1_k$(_this__u8e3s4) {
        // Inline function 'org.thecommunitygroupinc.cares.views.components.page' call
        var this_0 = get_scrolling(_this__u8e3s4);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_1 = maxWidth(this_0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element = new (RowOrCol())(this_1.get_context_h02k06_k$());
        ensureOutermostElement(element);
        this_1.willAddChild_hz2iwc_k$(element);
        element.set_vertical_nuap32_k$(true);
        element.set_themeBase_daz04n_k$(Companion_getInstance().fromParentNonCascading_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        var this_2 = themed(element, CompactSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_0 = new (RowOrCol())(this_2.get_context_h02k06_k$());
        ensureOutermostElement(element_0);
        this_2.willAddChild_hz2iwc_k$(element_0);
        element_0.set_vertical_nuap32_k$(false);
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        var this_3 = get_atBottomStart(element_0);
        // Inline function 'com.lightningkite.kiteui.views.direct.h1' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        var this_4 = weight(this_3, 1.0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_1 = new (TextView())(this_4.get_context_h02k06_k$());
        ensureOutermostElement(element_1);
        this_4.willAddChild_hz2iwc_k$(element_1);
        element_1.set_themeChoice_py59um_k$(element_1.get_themeChoice_22tyn3_k$().plus_duvq05_k$(HeaderSemantic_getInstance().plus_duvq05_k$(get_H1Semantic())));
        var tmp = KMutableProperty0();
        var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_1);
        var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_1));
        element_1.invoke_bnq13k_k$(tmp_1, AttendancePeriodsListPage$render$lambda);
        element_1.onStartup_vrxh3i_k$();
        this_4.addChild_2qpft2_k$(element_1);
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        var this_5 = weight(element_0, 1.0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_2 = new (Space())(this_5.get_context_h02k06_k$());
        ensureOutermostElement(element_2);
        this_5.willAddChild_hz2iwc_k$(element_2);
        element_2.onStartup_vrxh3i_k$();
        this_5.addChild_2qpft2_k$(element_2);
        sortSelect(element_0, ($this$sortSelect) => {
          var tmp = _Constant___init__impl__v45mub(toList(get_entries()));
          $this$sortSelect.bind_64a41i_k$(this.sort_1, new (Constant())(tmp), AttendancePeriodsListPage$render$lambda$lambda);
          return Unit_instance;
        });
        attendancePeriodFilters(element_0, this.filter_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.menuButton' call
        var this_6 = themed(sizeConstraints(element_0, VOID, VOID, VOID, VOID, 1.0), IconButtonSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_3 = new (MenuButton())(this_6.get_context_h02k06_k$());
        ensureOutermostElement(element_3);
        this_6.willAddChild_hz2iwc_k$(element_3);
        // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
        var this_7 = get_centered(element_3);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_4 = new (IconView())(this_7.get_context_h02k06_k$());
        ensureOutermostElement(element_4);
        this_7.willAddChild_hz2iwc_k$(element_4);
        element_4.set_source_3o5lkf_k$(Companion_getInstance_1().download_1.resize_q1xpz0_k$(get_rem(1.25)));
        var tmp_2 = KMutableProperty0();
        var tmp_3 = IconView$_get_description_$ref_x7iif6(element_4);
        var tmp_4 = getPropertyCallableRef('description', 0, tmp_2, tmp_3, IconView$_set_description_$ref_rpvc1e(element_4));
        element_4.invoke_bnq13k_k$(tmp_4, AttendancePeriodsListPage$render$lambda_0);
        element_4.onStartup_vrxh3i_k$();
        this_7.addChild_2qpft2_k$(element_4);
        element_3.requireClick_1 = true;
        element_3.set_preferredDirection_gql2kx_k$(Companion_getInstance_2().belowLeft_1);
        element_3.opensMenu_gggyad_k$(($this$opensMenu) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          var this_0 = themed($this$opensMenu, ListSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (RowOrCol())(this_0.get_context_h02k06_k$());
          ensureOutermostElement(element);
          this_0.willAddChild_hz2iwc_k$(element);
          element.set_vertical_nuap32_k$(true);
          // Inline function 'com.lightningkite.kiteui.views.compact' call
          // Inline function 'com.lightningkite.kiteui.views.direct.button' call
          var this_1 = themed(element, CompactSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_0 = new (Button())(this_1.get_context_h02k06_k$());
          ensureOutermostElement(element_0);
          this_1.willAddChild_hz2iwc_k$(element_0);
          text(element_0, 'Attendance periods');
          element_0.set_action_2ds022_k$(Action('Export attendance periods', VOID, VOID, VOID, VOID, VOID, AttendancePeriodsListPage$render$lambda$slambda(this, element_0)));
          element_0.onStartup_vrxh3i_k$();
          this_1.addChild_2qpft2_k$(element_0);
          // Inline function 'com.lightningkite.kiteui.views.compact' call
          // Inline function 'com.lightningkite.kiteui.views.direct.button' call
          var this_2 = themed(element, CompactSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_1 = new (Button())(this_2.get_context_h02k06_k$());
          ensureOutermostElement(element_1);
          this_2.willAddChild_hz2iwc_k$(element_1);
          text(element_1, 'Attendance sheets');
          element_1.set_action_2ds022_k$(Action('Export attendance sheets', VOID, VOID, VOID, VOID, VOID, AttendancePeriodsListPage$render$lambda$slambda_0(this, element_1)));
          element_1.onStartup_vrxh3i_k$();
          this_2.addChild_2qpft2_k$(element_1);
          // Inline function 'com.lightningkite.kiteui.views.compact' call
          // Inline function 'com.lightningkite.kiteui.views.direct.button' call
          var this_3 = themed(element, CompactSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_2 = new (Button())(this_3.get_context_h02k06_k$());
          ensureOutermostElement(element_2);
          this_3.willAddChild_hz2iwc_k$(element_2);
          text(element_2, 'Blank sheets');
          element_2.set_action_2ds022_k$(Action('Export blank attendance sheets', VOID, VOID, VOID, VOID, VOID, AttendancePeriodsListPage$render$lambda$slambda_1(this, element_2)));
          element_2.onStartup_vrxh3i_k$();
          this_3.addChild_2qpft2_k$(element_2);
          element.onStartup_vrxh3i_k$();
          this_0.addChild_2qpft2_k$(element);
          return Unit_instance;
        });
        element_3.onStartup_vrxh3i_k$();
        this_6.addChild_2qpft2_k$(element_3);
        element_0.onStartup_vrxh3i_k$();
        this_2.addChild_2qpft2_k$(element_0);
        filterChips(element, this.filter_1);
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        var tmp_5 = weight(element, 1.0);
        var tmp_6 = remember(VOID, VOID, VOID, VOID, ($this$remember) => $this$remember.invoke_r7m7el_k$(this.data_1));
        var tmp_7 = AttendancePeriodsListPage$render$lambda_1;
        var tmp_8 = Companion_instance_1;
        var tmp_9 = AttendancePeriodsListPage$render$lambda_2;
        var tmp_10 = tmp_8.text_y5ktm4_k$(tmp_9, 0.75, AttendancePeriodsListPage$render$lambda_3);
        var tmp_11 = Companion_instance_1;
        var tmp_12 = AttendancePeriodsListPage$render$lambda_4;
        var tmp_13 = tmp_11.text$default_gwb2zv_k$(tmp_12, VOID, AttendancePeriodsListPage$render$lambda_5);
        var tmp_14 = Companion_instance_1;
        var tmp_15 = AttendancePeriodsListPage$render$lambda_6;
        var tmp_16 = tmp_14.custom_k0krgj_k$(tmp_15, 0.5, AttendancePeriodsListPage$render$lambda_7);
        var tmp_17 = Companion_instance_1;
        var tmp_18 = AttendancePeriodsListPage$render$lambda_8;
        tableRecycler(tmp_5, tmp_6, tmp_7, [tmp_10, tmp_13, tmp_16, tmp_17.custom_k0krgj_k$(tmp_18, 0.5, AttendancePeriodsListPage$render$lambda_9)]);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        var this_8 = shownWhen(element, VOID, VOID, AttendancePeriodsListPage$render$lambda_10);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_5 = new (Space())(this_8.get_context_h02k06_k$(), 1.0);
        ensureOutermostElement(element_5);
        this_8.willAddChild_hz2iwc_k$(element_5);
        element_5.onStartup_vrxh3i_k$();
        this_8.addChild_2qpft2_k$(element_5);
        element.onStartup_vrxh3i_k$();
        this_1.addChild_2qpft2_k$(element);
        return Unit_instance;
      }
    }
    initMetadataForClass($, 'AttendancePeriodsListPage', AttendancePeriodsListPage, VOID, [Page()]);
    AttendancePeriodsListPageClass = $;
  }
  return AttendancePeriodsListPageClass;
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {
      *fetchAll_q0i359_k$(api, condition, $completion) {
        var tmp = api.get_locationAttendancePeriod_ojr4ns_k$();
        var tmp0_limit = 2147483647;
        // Inline function 'com.lightningkite.services.database.sort' call
        // Inline function 'kotlin.apply' call
        var this_0 = new (SortBuilder())();
        // Inline function 'com.lightningkite.services.database.path' call
        // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
        var tmp_0 = serializerOrContextual(createKType(getKClass(LocationAttendancePeriod()), arrayOf([]), false));
        var tmp$ret$4 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
        var it = new (DataClassPathSelf())(tmp$ret$4);
        this_0.descending_tl4o2_k$(get_start(get_period(it)));
        var tmp1_orderBy = this_0.build_1k0s4u_k$();
        var periods = yield* tmp.query_o986pg_k$(new (Query())(condition, tmp1_orderBy, VOID, tmp0_limit), $completion);
        // Inline function 'kotlin.collections.map' call
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(periods, 10));
        var _iterator__ex2g4s = periods.iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var item = _iterator__ex2g4s.next_20eer_k$();
          var tmp$ret$8 = new (ID_0())(item.provider_1);
          destination.add_utx5q5_k$(tmp$ret$8);
        }
        var providerIds = toSet(destination);
        var tmp_1 = api.get_careProvider_y0cmmt_k$();
        var tmp2 = 2147483647;
        // Inline function 'com.lightningkite.services.database.Query' call
        // Inline function 'kotlin.collections.listOf' call
        var orderBy = emptyList();
        // Inline function 'com.lightningkite.services.database.path' call
        // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
        var tmp_2 = serializerOrContextual(createKType(getKClass(CareProvider()), arrayOf([]), false));
        var tmp$ret$12 = isInterface(tmp_2, KSerializer()) ? tmp_2 : THROW_CCE();
        var it_0 = new (DataClassPathSelf())(tmp$ret$12);
        var tmp$ret$13 = xDataClassPathInsideSet(get__id(it_0), providerIds);
        var tmp$ret$9 = new (Query())(tmp$ret$13, orderBy, 0, tmp2);
        // Inline function 'kotlin.collections.associate' call
        var this_1 = yield* tmp_1.query_o986pg_k$(tmp$ret$9, $completion);
        var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_1, 10)), 16);
        // Inline function 'kotlin.collections.associateTo' call
        var destination_0 = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(capacity);
        var _iterator__ex2g4s_0 = this_1.iterator_jk1svi_k$();
        while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
          var element = _iterator__ex2g4s_0.next_20eer_k$();
          // Inline function 'kotlin.collections.plusAssign' call
          var pair = to(new (ID_0())(element._id_1), element.name_1);
          destination_0.put_4fpzoq_k$(pair.first_1, pair.second_1);
        }
        var providerNames = destination_0;
        // Inline function 'kotlin.collections.map' call
        // Inline function 'kotlin.collections.mapTo' call
        var destination_1 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(periods, 10));
        var _iterator__ex2g4s_1 = periods.iterator_jk1svi_k$();
        while (_iterator__ex2g4s_1.hasNext_bitz1p_k$()) {
          var item_0 = _iterator__ex2g4s_1.next_20eer_k$();
          var tmp$ret$20 = new (ID())(item_0.location_1);
          destination_1.add_utx5q5_k$(tmp$ret$20);
        }
        var locationIds = toSet(destination_1);
        var tmp_3 = api.get_careLocation_drerzj_k$();
        var tmp2_0 = 2147483647;
        // Inline function 'com.lightningkite.services.database.Query' call
        // Inline function 'kotlin.collections.listOf' call
        var orderBy_0 = emptyList();
        // Inline function 'com.lightningkite.services.database.path' call
        // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
        var tmp_4 = serializerOrContextual(createKType(getKClass(CareLocation()), arrayOf([]), false));
        var tmp$ret$24 = isInterface(tmp_4, KSerializer()) ? tmp_4 : THROW_CCE();
        var it_1 = new (DataClassPathSelf())(tmp$ret$24);
        var tmp$ret$25 = xDataClassPathInsideSet(get__id_0(it_1), locationIds);
        var tmp$ret$21 = new (Query())(tmp$ret$25, orderBy_0, 0, tmp2_0);
        // Inline function 'kotlin.collections.associate' call
        var this_2 = yield* tmp_3.query_o986pg_k$(tmp$ret$21, $completion);
        var capacity_0 = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_2, 10)), 16);
        // Inline function 'kotlin.collections.associateTo' call
        var destination_2 = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(capacity_0);
        var _iterator__ex2g4s_2 = this_2.iterator_jk1svi_k$();
        while (_iterator__ex2g4s_2.hasNext_bitz1p_k$()) {
          var element_0 = _iterator__ex2g4s_2.next_20eer_k$();
          // Inline function 'kotlin.collections.plusAssign' call
          var pair_0 = to(new (ID())(element_0._id_1), element_0.name_1);
          destination_2.put_4fpzoq_k$(pair_0.first_1, pair_0.second_1);
        }
        var locationNames = destination_2;
        // Inline function 'kotlin.collections.flatMap' call
        // Inline function 'kotlin.collections.flatMapTo' call
        var destination_3 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
        var _iterator__ex2g4s_3 = periods.iterator_jk1svi_k$();
        while (_iterator__ex2g4s_3.hasNext_bitz1p_k$()) {
          var element_1 = _iterator__ex2g4s_3.next_20eer_k$();
          var tmp0_safe_receiver = element_1.submitted_1;
          var tmp_5 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.by_1;
          var tmp_6 = tmp_5 == null ? null : new (ID_1())(tmp_5);
          var tmp1_safe_receiver = element_1.approved_1;
          var tmp_7 = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.by_1;
          var list = listOfNotNull([tmp_6, tmp_7 == null ? null : new (ID_1())(tmp_7)]);
          addAll(destination_3, list);
        }
        var userIds = toSet(destination_3);
        var tmp_8 = api.get_user_wovspg_k$();
        var tmp2_1 = 2147483647;
        // Inline function 'com.lightningkite.services.database.Query' call
        // Inline function 'kotlin.collections.listOf' call
        var orderBy_1 = emptyList();
        // Inline function 'com.lightningkite.services.database.path' call
        // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
        var tmp_9 = serializerOrContextual(createKType(getKClass(User()), arrayOf([]), false));
        var tmp$ret$36 = isInterface(tmp_9, KSerializer()) ? tmp_9 : THROW_CCE();
        var it_2 = new (DataClassPathSelf())(tmp$ret$36);
        var tmp$ret$37 = xDataClassPathInsideSet(get__id_1(it_2), userIds);
        var tmp$ret$33 = new (Query())(tmp$ret$37, orderBy_1, 0, tmp2_1);
        // Inline function 'kotlin.collections.associate' call
        var this_3 = yield* tmp_8.query_o986pg_k$(tmp$ret$33, $completion);
        var capacity_1 = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_3, 10)), 16);
        // Inline function 'kotlin.collections.associateTo' call
        var destination_4 = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(capacity_1);
        var _iterator__ex2g4s_4 = this_3.iterator_jk1svi_k$();
        while (_iterator__ex2g4s_4.hasNext_bitz1p_k$()) {
          var element_2 = _iterator__ex2g4s_4.next_20eer_k$();
          // Inline function 'kotlin.collections.plusAssign' call
          var pair_1 = to(new (ID_1())(element_2._id_1), element_2.name_1);
          destination_4.put_4fpzoq_k$(pair_1.first_1, pair_1.second_1);
        }
        var userNames = destination_4;
        // Inline function 'kotlin.collections.map' call
        // Inline function 'kotlin.collections.mapTo' call
        var destination_5 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(periods, 10));
        var _iterator__ex2g4s_5 = periods.iterator_jk1svi_k$();
        while (_iterator__ex2g4s_5.hasNext_bitz1p_k$()) {
          var item_1 = _iterator__ex2g4s_5.next_20eer_k$();
          var tmp0_elvis_lhs = providerNames.get_wei43m_k$(new (ID_0())(item_1.provider_1));
          var tmp_10 = tmp0_elvis_lhs == null ? 'NOT FOUND' : tmp0_elvis_lhs;
          var tmp1_elvis_lhs = locationNames.get_wei43m_k$(new (ID())(item_1.location_1));
          var tmp_11 = tmp1_elvis_lhs == null ? 'NOT FOUND' : tmp1_elvis_lhs;
          var tmp2_safe_receiver = item_1.submitted_1;
          var tmp_12 = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.at_1;
          var tmp3_safe_receiver = item_1.submitted_1;
          var tmp_13;
          if (tmp3_safe_receiver == null) {
            tmp_13 = null;
          } else {
            // Inline function 'kotlin.let' call
            var tmp0_elvis_lhs_0 = userNames.get_wei43m_k$(new (ID_1())(tmp3_safe_receiver.by_1));
            tmp_13 = tmp0_elvis_lhs_0 == null ? 'NOT FOUND' : tmp0_elvis_lhs_0;
          }
          var tmp_14 = tmp_13;
          var tmp4_safe_receiver = item_1.approved_1;
          var tmp_15 = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.at_1;
          var tmp5_safe_receiver = item_1.approved_1;
          var tmp_16;
          if (tmp5_safe_receiver == null) {
            tmp_16 = null;
          } else {
            // Inline function 'kotlin.let' call
            var tmp0_elvis_lhs_1 = userNames.get_wei43m_k$(new (ID_1())(tmp5_safe_receiver.by_1));
            tmp_16 = tmp0_elvis_lhs_1 == null ? 'NOT FOUND' : tmp0_elvis_lhs_1;
          }
          var tmp$ret$44 = new (AttendancePeriodCsvRow())(item_1.period_1.start_1, item_1.period_1.endInclusive_1, tmp_10, tmp_11, tmp_12, tmp_14, tmp_15, tmp_16);
          destination_5.add_utx5q5_k$(tmp$ret$44);
        }
        return destination_5;
      }
      serializer_9w0wvi_k$() {
        return $serializer_getInstance();
      }
    }
    initMetadataForCompanion($, VOID, VOID, [2]);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_3;
function Companion_getInstance_4() {
  return Companion_instance_3;
}
var $serializerClass;
function $serializer() {
  if ($serializerClass === VOID) {
    class $ {
      constructor() {
        $serializer_instance = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('org.thecommunitygroupinc.cares.views.attendance.AttendancePeriodCsvRow', this, 8);
        tmp0_serialDesc.addElement_5pzumi_k$('start', false);
        tmp0_serialDesc.addElement_5pzumi_k$('endInclusive', false);
        tmp0_serialDesc.addElement_5pzumi_k$('provider', false);
        tmp0_serialDesc.addElement_5pzumi_k$('location', false);
        tmp0_serialDesc.addElement_5pzumi_k$('submittedAt', false);
        tmp0_serialDesc.addElement_5pzumi_k$('submittedBy', false);
        tmp0_serialDesc.addElement_5pzumi_k$('approvedAt', false);
        tmp0_serialDesc.addElement_5pzumi_k$('approvedBy', false);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_xz1h20_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 0, LocalDateSerializer_getInstance(), value.start_1);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 1, LocalDateSerializer_getInstance(), value.endInclusive_1);
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 2, value.provider_1);
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 3, value.location_1);
        tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 4, InstantSerializer_getInstance(), value.submittedAt_1);
        tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 5, StringSerializer_getInstance(), value.submittedBy_1);
        tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 6, InstantSerializer_getInstance(), value.approvedAt_1);
        tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 7, StringSerializer_getInstance(), value.approvedBy_1);
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_xz1h20_k$(encoder, value instanceof AttendancePeriodCsvRow() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_local7 = null;
        var tmp12_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp12_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp12_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, LocalDateSerializer_getInstance(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp12_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, LocalDateSerializer_getInstance(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp12_input.decodeStringElement_3oenpg_k$(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp12_input.decodeStringElement_3oenpg_k$(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp12_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 4, InstantSerializer_getInstance(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp12_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp12_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 6, InstantSerializer_getInstance(), tmp10_local6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          tmp11_local7 = tmp12_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 7, StringSerializer_getInstance(), tmp11_local7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp12_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp12_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, LocalDateSerializer_getInstance(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp12_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, LocalDateSerializer_getInstance(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp12_input.decodeStringElement_3oenpg_k$(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp12_input.decodeStringElement_3oenpg_k$(tmp0_desc, 3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp12_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 4, InstantSerializer_getInstance(), tmp8_local4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp12_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp12_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 6, InstantSerializer_getInstance(), tmp10_local6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              case 7:
                tmp11_local7 = tmp12_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 7, StringSerializer_getInstance(), tmp11_local7);
                tmp3_bitMask0 = tmp3_bitMask0 | 128;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp12_input.endStructure_1xqz0n_k$(tmp0_desc);
        return AttendancePeriodCsvRow().new_org_thecommunitygroupinc_cares_views_attendance_AttendancePeriodCsvRow_5knys2_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [LocalDateSerializer_getInstance(), LocalDateSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(InstantSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(InstantSerializer_getInstance()), get_nullable(StringSerializer_getInstance())];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var $serializer_instance;
function $serializer_getInstance() {
  if ($serializer_instance === VOID)
    new ($serializer())();
  return $serializer_instance;
}
var AttendancePeriodCsvRowClass;
function AttendancePeriodCsvRow() {
  if (AttendancePeriodCsvRowClass === VOID) {
    class $ {
      constructor(start, endInclusive, provider, location, submittedAt, submittedBy, approvedAt, approvedBy) {
        this.start_1 = start;
        this.endInclusive_1 = endInclusive;
        this.provider_1 = provider;
        this.location_1 = location;
        this.submittedAt_1 = submittedAt;
        this.submittedBy_1 = submittedBy;
        this.approvedAt_1 = approvedAt;
        this.approvedBy_1 = approvedBy;
      }
      toString() {
        return 'AttendancePeriodCsvRow(start=' + this.start_1.toString() + ', endInclusive=' + this.endInclusive_1.toString() + ', provider=' + this.provider_1 + ', location=' + this.location_1 + ', submittedAt=' + toString(this.submittedAt_1) + ', submittedBy=' + this.submittedBy_1 + ', approvedAt=' + toString(this.approvedAt_1) + ', approvedBy=' + this.approvedBy_1 + ')';
      }
      hashCode() {
        var result = this.start_1.hashCode();
        result = imul(result, 31) + this.endInclusive_1.hashCode() | 0;
        result = imul(result, 31) + getStringHashCode(this.provider_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.location_1) | 0;
        result = imul(result, 31) + (this.submittedAt_1 == null ? 0 : this.submittedAt_1.hashCode()) | 0;
        result = imul(result, 31) + (this.submittedBy_1 == null ? 0 : getStringHashCode(this.submittedBy_1)) | 0;
        result = imul(result, 31) + (this.approvedAt_1 == null ? 0 : this.approvedAt_1.hashCode()) | 0;
        result = imul(result, 31) + (this.approvedBy_1 == null ? 0 : getStringHashCode(this.approvedBy_1)) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof AttendancePeriodCsvRow()))
          return false;
        if (!this.start_1.equals(other.start_1))
          return false;
        if (!this.endInclusive_1.equals(other.endInclusive_1))
          return false;
        if (!(this.provider_1 === other.provider_1))
          return false;
        if (!(this.location_1 === other.location_1))
          return false;
        if (!equals(this.submittedAt_1, other.submittedAt_1))
          return false;
        if (!(this.submittedBy_1 == other.submittedBy_1))
          return false;
        if (!equals(this.approvedAt_1, other.approvedAt_1))
          return false;
        if (!(this.approvedBy_1 == other.approvedBy_1))
          return false;
        return true;
      }
      static new_org_thecommunitygroupinc_cares_views_attendance_AttendancePeriodCsvRow_5knys2_k$(seen0, start, endInclusive, provider, location, submittedAt, submittedBy, approvedAt, approvedBy, serializationConstructorMarker) {
        if (!(255 === (255 & seen0))) {
          throwMissingFieldException(seen0, 255, $serializer_getInstance().descriptor_1);
        }
        var $this = createThis(this);
        $this.start_1 = start;
        $this.endInclusive_1 = endInclusive;
        $this.provider_1 = provider;
        $this.location_1 = location;
        $this.submittedAt_1 = submittedAt;
        $this.submittedBy_1 = submittedBy;
        $this.approvedAt_1 = approvedAt;
        $this.approvedBy_1 = approvedBy;
        return $this;
      }
    }
    initMetadataForClass($, 'AttendancePeriodCsvRow', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance});
    AttendancePeriodCsvRowClass = $;
  }
  return AttendancePeriodCsvRowClass;
}
//region block: init
Companion_instance_3 = new (Companion_0())();
//endregion
//region block: exports
export {
  SortOption as SortOption1cigvg09nc86u,
  AttendancePeriodsListPage as AttendancePeriodsListPagekcmctzhabmp9,
};
//endregion

//# sourceMappingURL=AttendancePeriodsListPage.mjs.map
